<template>
  <v-app>
    <v-main>
      <v-container
        fluid
        class="pl-5 pr-5"
      >
        <v-row>
          <router-view />
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script type="text/javascript">
export default {};
</script>
